import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class SequenceSearchResultDataResponse {
  @jsonMember readonly program!: string;
  @jsonMember readonly version!: string;
  @jsonMember readonly queryId!: string;
  @jsonMember readonly queryLength!: number;
  @jsonMember readonly queryTitle!: string;
  @jsonMember readonly reference!: string;
  @jsonMember({ name: 'searchTargetDb' }) readonly database!: string;
}
